// @flow

import React from "react";
import { localize } from "redux-i18n";

import { SchemaForm, SectionComponent, Button } from "@components";
import actionCreators from "@modules/service/actionCreator";
import type {
  ServiceSettingsContainer,
  ServiceSettings,
} from "@modules/service/reducer/service-settings/types";

import uiSchema from "./ui-schema";

type Props = $Exact<{
  serviceSettings: Object,
  settings: ServiceSettingsContainer,
  schema: Object,
  editDisabed: boolean,
  clientId: ?number,
  updateSettings: typeof actionCreators.UpdateServiceSettings,
  ...PropsFromLocalize,
}>;

type OwnState = $Exact<{
  edit: boolean,
}>;

export class ServiceSettingsMainSettingsView extends React.Component<Props, OwnState> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }
  state = {
    edit: false,
  };

  get settings(): ?ServiceSettings {
    return this.props.settings.active;
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  toggleEdit = () => {
    this.setState({
      edit: !this.state.edit,
    });
  };

  submitHandler = (formData: Object) => {
    this.props.updateSettings({
      clientId: this.props.clientId,
      settings: {
        ...formData,
        rtwDiscussionType: "EMPLOYEE_LED",
        timeInAdvanceAbsenceCanBeOpened: 5184000, // 60 days in seconds
        allowEmployeeToUpdateAndCloseAbsencesInSameTransaction: true,
        allowEmployeeToOpenAndCloseAbsencesInSameTransaction: true,
      },
    });
    this.toggleEdit();
  };

  cancelEdit = () => {
    this.setState({
      edit: false,
    });
  };

  get uiSchema() {
    const result = uiSchema(this.props.t);
    return result;
  }

  get schema() {
    const { schema } = this.props;
    return {
      ...schema,
      properties: {
        ...schema.properties,
        announcement: {
          type: "string",
          title: this.props.t("ANNOUNCEMENT"),
          maxLength: 1000,
        },
        medicalOnly: {
          type: "string",
          title: this.props.t("NON_MEDICAL_RULE"),
        },
      },
    };
  }

  render() {
    if (!this.settings) return <div />;
    return (
      <SectionComponent
        title={<h5>{this.props.t("SERVICE_SETTINGS_ABSENCE_RECORDING")}</h5>}
        rightLink={
          <div>
            {!this.state.edit ? (
              <Button
                materialIcon="edit"
                onClick={this.toggleEdit}
                disabled={this.props.editDisabed}
              >
                {this.props.t("EDIT")}
              </Button>
            ) : (
              <div className="d-flex">
                <Button color="secondary" onClick={this.cancelEdit}>
                  {this.props.t("CANCEL")}
                </Button>
                <Button
                  materialIcon="replay_circle_filled"
                  className="ml-2"
                  onClick={this.submitForm}
                >
                  {this.props.t("SUBMIT")}
                </Button>
              </div>
            )}
          </div>
        }
      >
        <SchemaForm
          schema={this.schema}
          uiSchema={this.uiSchema}
          formData={this.props.settings.active}
          ref={this.formRef}
          readonly={!this.state.edit}
          onSubmit={this.submitHandler}
          externalSubmit
          boxGrid
        />
      </SectionComponent>
    );
  }
}

export default localize()(ServiceSettingsMainSettingsView);
